export const darkColor  = '#282828';
export const lightColor = '#FFFFFF';
export const dataFontColor = '#000000d9';